import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/providers/AuthProvider";
import { configureAuth } from "@/lib/auth-fetch";
import { TourProvider } from "@/contexts/TourContext";
import { ProductTour } from "@/components/ProductTour";
import { CompanyProvider } from "@/features/multi-company";
import { WootricProvider } from "@/providers/WootricProvider";
import { useUserProfile } from "@/hooks/useUserProfile";
import App from "@/App";
import { useEffect } from "react";
interface AppContainerProps {
  settings?: {
    apiUrl?: string;
    clientId?: string;
    defaultUrl?: string;
    identityUrl?: string;
    redirectUri?: string;
    scope?: string;
    workspaceUrl?: string;
  };
}

export default function AppContainer({ settings }: AppContainerProps = {}): React.ReactElement {
  const { getAccessToken, instanceId } = useAuth();
  const { user: wootricUser } = useUserProfile();

  useEffect(() => {
    configureAuth({ getAccessToken, instanceId });
  }, [getAccessToken, instanceId]);

  return (
    <QueryProvider>
      <TooltipProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
          <CompanyProvider>
            <TourProvider>
              <WootricProvider user={wootricUser}>
                <Toaster richColors duration={5000} closeButton />
                <ProductTour />
                <App />
              </WootricProvider>
            </TourProvider>
          </CompanyProvider>
        </ThemeProvider>
      </TooltipProvider>
    </QueryProvider>
  );
}
